
// You can write more code here

/* START OF COMPILED CODE */

import EditorMarker from "../EditorMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicMarker extends EditorMarker {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 52, y ?? 33, texture || 'game-all', frame ?? "relic-boots.png");

    this.scaleX = 0.35;
    this.scaleY = 0.35;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
